import React from 'react';
import { TFileId, TLanguageIDs, TMediaFileType, IMaxFileSizeMBStyleSettings } from 'types';
import StyleSettingsImageUploaderState from './styleSettingsImageUploaderState/StyleSettingsImageUploaderState';
import { UploaderNew } from './components/UploaderNew';
import { CropperModalNew } from './components/CropperModalNew';
import { ErrorModalsNew } from './components/ErrorModalsNew';

interface IProps {
	filePath: Nullable<string>;
	itemKey: Nullable<string>;
	horizontalAspectRatio?: number;
	verticalAspectRatio?: number;
	maxFileSizeMB?: IMaxFileSizeMBStyleSettings;
	translationId: string;
	languageId: TLanguageIDs;
	groupId: string;
	groupKey: string;
	isNeedImgHeading: boolean;
	mediaFileType: TMediaFileType;
	groupLoading: boolean;
	isMakeImageRequest: boolean;
	isDisabledControls?: boolean;
	showGroupLoader: () => void;
	hideGroupLoader: () => void;
	setMediaSettingsFromNormalDisplay: (
		languageId: Nullable<TLanguageIDs>,
		groupId: string,
		translationId: string,
		mediaFileType: TMediaFileType,
		sourceUrl: string,
		fileId: TFileId,
	) => void;
}

export const StyleSettingsImageUploaderNew: React.FC<IProps> = ({
	filePath,
	itemKey,
	horizontalAspectRatio,
	verticalAspectRatio,
	maxFileSizeMB,
	translationId,
	languageId,
	groupId,
	groupKey,
	isNeedImgHeading,
	mediaFileType,
	groupLoading,
	isMakeImageRequest,
	isDisabledControls,
	showGroupLoader,
	hideGroupLoader,
	setMediaSettingsFromNormalDisplay,
}) => {
	const deleteFromNormalDisplayHandler = () => {
		setMediaSettingsFromNormalDisplay(languageId, groupId, translationId, mediaFileType, '', null);
	};

	return (
		<StyleSettingsImageUploaderState>
			<UploaderNew
				filePath={filePath}
				itemKey={itemKey}
				translationId={translationId}
				isNeedImgHeading={isNeedImgHeading}
				isDisabledControls={isDisabledControls}
				groupLoading={groupLoading}
				isMakeImageRequest={isMakeImageRequest}
				deleteFromNormalDisplayHandler={deleteFromNormalDisplayHandler}
			/>
			<CropperModalNew
				filePath={filePath}
				itemKey={itemKey}
				horizontalAspectRatio={horizontalAspectRatio}
				verticalAspectRatio={verticalAspectRatio}
				maxFileSizeMB={maxFileSizeMB}
				translationId={translationId}
				languageId={languageId}
				groupId={groupId}
				mediaFileType={mediaFileType}
				hasAbilityToUploadGif={['cards'].includes(groupKey)}
				showGroupLoader={showGroupLoader}
				hideGroupLoader={hideGroupLoader}
				setMediaSettingsFromNormalDisplay={setMediaSettingsFromNormalDisplay}
			/>
			<ErrorModalsNew maxFileSizeMB={maxFileSizeMB} />
		</StyleSettingsImageUploaderState>
	);
};
